import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import {
  Card,
  Table,
  ButtonGroup,
  Button,
  InputGroup,
  Form,
} from "react-bootstrap";
import { ThreeDots } from 'react-loader-spinner';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilSquare, faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { getCompanies } from "../../3.Store/CompanySlice";
import Pagination from "../../2.Commons/Pagination";

const CompanyList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const companies = useSelector((state) => state.CompanySlice.companies || []);
  const [loading, setLoading] = useState(false);
  const role = JSON.parse(localStorage.getItem("roles"));
  const [searchText, setSearchText] = useState("");

  // Filter by description
  const filteredCompanies = companies.filter(c =>
    c.description?.toLowerCase().includes(searchText.toLowerCase())
  );

  // Pagination logic
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;
  const totalPages = Math.ceil(filteredCompanies.length / itemsPerPage);
  const currentItems = filteredCompanies.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  useEffect(() => {
    setLoading(true);

    if (!role || !role.includes("HR-L-AWARD")) {
      localStorage.clear();
      window.location.href = "/Login";
    }

    dispatch(getCompanies())
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });

  }, [])

  const handleSearch = (e) => {
    setSearchText(e.target.value);
    setCurrentPage(1);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      setCurrentPage(1);
    }
  };

  const handleBtnBack = () => {
    navigate("/");
  };

  const handleBtnCreate = () => {
    navigate(`/CompanyForm`);
  };

  const handleClickView = (id) => {
    navigate(`/CompanyForm/${id}`);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const renderLengthList = () => {
    return currentItems.map(catagory => (
      <tr key={catagory?.id} style={{ cursor: "pointer" }}>
        <td>{catagory?.short_description}</td>
        <td>{catagory?.description}</td>
        <td onClick={() => handleClickView(catagory?.id)}>
          <FontAwesomeIcon icon={faPenToSquare} style={{ color: "blue" }} />
        </td>
      </tr>
    ));
  };

  return (
    <div className="ContainerContent2">
      {loading && (
        <ThreeDots
          visible={loading}
          height="80"
          width="80"
          color="#4fa94d"
          radius="9"
          ariaLabel="three-dots-loading"
          wrapperStyle={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: '9999',
          }}
        />
      )}
      <Card className="CardContent">
        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>
        </div>

        <h1 className="TitleHeader">Company</h1>
        <h1 className="MiniTitleHeader">List</h1>

        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          handlePreviousPage={handlePreviousPage}
          handleNextPage={handleNextPage}
          handlePageChange={handlePageChange}
        />

        <InputGroup className="mb-3">
          <Form.Control 
            placeholder="Search" 
            value={searchText} 
            onChange={handleSearch} 
            onKeyPress={handleKeyPress}
          />
        </InputGroup>

        <div style={{ overflowX: 'auto' }}>
          <Table borderless className="mt-3 my-fixed-table text-center" style={{ fontSize: "14px", cursor: "pointer" }}>
            <thead>
              <tr>
                <th>Short Description</th>
                <th>Description</th>
                <th>
                  <FontAwesomeIcon icon={faPencilSquare} title="Action" />
                </th>
              </tr>
            </thead>
            {!loading && (
              <tbody>
                {currentItems.length > 0 ? (
                  renderLengthList()
                ) : (
                  <tr>
                    <td colSpan="3">No results found</td>
                  </tr>
                )}
              </tbody>
            )}
          </Table>
        </div>

        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          handlePreviousPage={handlePreviousPage}
          handleNextPage={handleNextPage}
          handlePageChange={handlePageChange}
        />

        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>
          &nbsp; &nbsp;
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnCreate}>
              Add
            </Button>
          </ButtonGroup>
        </div>
      </Card>
    </div>
  );
};
export default CompanyList;